export const mockDataSideBySide = {
  success: true,
  sideBySidePreview: {
    firstName: {
      5: "Oscar",
      6: "Oscar",
    },
    lastName: {
      5: "Brown",
      6: "White",
    },
    photo: {
      5: "//d6iyrqjd26xke.cloudfront.net/img19072/profile.jpg",
      6: "//d6iyrqjd26xke.cloudfront.net/clearlakefamilycopy/profile.jpg",
    },
    email: {
      5: {
        value: "markadamfoster+userafinal@gmail.com",
        verified: true,
      },
      6: {
        value: "markadamfoster+userbfinal@gmail.com",
        verified: false,
      },
    },
    phone: {
      5: {
        value: 5555555501,
        verified: true,
      },
      6: {
        value: 5555555501,
        verified: true,
      },
    },
    additionalContactInfo: {
      5: [
        { value: "oscar@extra.com", type: "Email" },
        { value: "1235554567", type: "Mobile Phone" },
      ],
      6: [{ value: "oscar@extra.com", type: "Email" }],
    },
    proxyContacts: {
      proxyFor: {
        5: [],
        6: [
          {
            userID: 580,
            photoURL: "https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg",
            displayName: "Child1 MergeTest1",
          },
          {
            userID: 581,
            photoURL: "https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg",
            displayName: "Child2 MergeTest1",
          },
        ],
      },
      targetFor: { 579: [], 578: [] },
    },
    adminGroups: {
      5: 3,
      6: 1,
    },
    householdName: {
      5: {
        name: "Brown",
        hasGivingData: false,
      },
      6: {
        name: "",
        hasGivingData: false,
      },
    },
    hasPassword: {
      5: true,
      6: false,
    },
    numRemarks: {
      5: 2,
      6: 0,
    },
    numDocuments: {
      5: 0,
      6: 0,
    },
    numAuthoredNotes: {
      5: 14,
      6: 0,
    },
    numComments: {
      5: 34,
      6: 0,
    },
    permissions: {
      1: {
        5: false,
        6: false,
        permissionDescription: "Has billing access",
        icon: "money-bill-wave fas far",
      },
      2: {
        5: true,
        6: true,
        permissionDescription: "Can input giving data",
        icon: "money-check-edit-alt fas far",
      },
      3: {
        5: false,
        6: false,
        permissionDescription: "Can view giving data",
        icon: "money-check-alt fas far",
      },
    },
    extendedFields: {
      25: {
        5: "some text",
        6: "some different text.",
        name: "Type something",
        icon: "font fas far",
      },
      26: {
        5: "1",
        6: "",
        name: "Test Number Everyone",
        icon: "info-circle fas far",
      },
      27: {
        5: "123 Main St, Atlanta, GA, 00000",
        6: "123 Main St, Atlanta, GA, 00000",
        name: "Address",
        icon: "map fas far",
      },
      28: {
        5: "January 1, 2000",
        6: "January 1, 2000",
        name: "Test Date",
        icon: "calendar fas far",
      },
      29: {
        5: "Option 2",
        6: "Option 2",
        name: "Test List Everyone",
        icon: "info-circle fas far",
      },
    },
    mergeUsers: [5, 6],
  },
  isApp: false,
  userID: 2,
};
